import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  createPayment,
  getPaymentTypes,
  createPaymentTypes,
  getPaymentById,
  getCashTransferById,
  createCashTransfer,
  patchPayment,
  deletePayment,
} from "./operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const PaymentsSlice = createSlice({
  name: "payments",
  initialState: initialState.payments,
  reducers: {
    clearPaymentInfo(state) {
      console.log("Clearing payment info");
      state.createdPaymentInfo = null;
    },
    clearCashTransfer(state) {
      state.cashTransfer = null;
    },
  },
  extraReducers: builder =>
    builder
      // Get payment types +
      .addCase(getPaymentTypes.pending, handlePending)
      .addCase(getPaymentTypes.fulfilled, (state, action) => {
        state.paymentTypes = action.payload;
        state.isLoading = false;
      })
      .addCase(getPaymentTypes.rejected, handleRejected)

      // Create payment type +
      .addCase(createPaymentTypes.pending, handlePending)
      .addCase(createPaymentTypes.fulfilled, (state, action) => {
        state.paymentTypes.push(action.payload);
        state.isLoading = false;
      })
      .addCase(createPaymentTypes.rejected, handleRejected)

      // Create income payment +
      .addCase(createPayment.pending, handlePending)
      .addCase(createPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.createdPaymentInfo = action.payload;
      })
      .addCase(createPayment.rejected, handleRejected)

      // Get Payment by Id (for Invoices page)+
      .addCase(getPaymentById.pending, handlePending)
      .addCase(getPaymentById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.createdPaymentInfo = action.payload;
      })
      .addCase(getPaymentById.rejected, handleRejected)

      // Patch income payment +
      .addCase(patchPayment.pending, handlePending)
      .addCase(patchPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.createdPaymentInfo = action.payload;
      })
      .addCase(patchPayment.rejected, handleRejected)

      // Get Payment Transfer By Id +
      .addCase(getCashTransferById.pending, handlePending)
      .addCase(getCashTransferById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cashTransfer = action.payload;
      })
      .addCase(getCashTransferById.rejected, handleRejected)

      // Create cash transfer between two legal entities +
      .addCase(createCashTransfer.pending, handlePending)
      .addCase(createCashTransfer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cashTransfer = action.payload;
      })
      .addCase(createCashTransfer.rejected, handleRejected)

      // Delete payment +
      .addCase(deletePayment.pending, handlePending)
      .addCase(deletePayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.createdPaymentInfo = action.payload;
      })
      .addCase(deletePayment.rejected, handleRejected),
});
export const { clearPaymentInfo, clearCashTransfer } = PaymentsSlice.actions;

export default PaymentsSlice.reducer;
